import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  hint: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  }
}))

export {
  useStyles
}